import React, { useState } from "react";
import { isEmpty, orderBy } from "lodash";
import { clsx } from "clsx";
// components
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
// enums
import EViewType from "@/cms/enums/EViewType";
// types
import TRMDRAccordion from "../type";


const RMDRAccordion01 = ( props:TRMDRAccordion ) => {
    console.log("RMDRAccordion01.rendered", props);

    const [activeAccordion, setActiveAccordion] = useState<string>("");

    const toggle = (id:string) => {
        if (activeAccordion !== id) setActiveAccordion(id);
    }

    if ( 
        !isEmpty(props.parentLanguageVersion) && props.parentLanguageVersion && 
        !isEmpty(props.parentLanguageVersion?.id) && props.parentLanguageVersion?.id && 
        props.parentLanguageVersion.viewType === EViewType.ACCORDION 
    ) {

        let payloadChild = props.languageVersions?.filter((item) => item.parentId === props.parentLanguageVersion?.id);

        if ( isEmpty(payloadChild) ) return null;

        payloadChild = orderBy(payloadChild, ['order'],['asc']);
        if ( isEmpty(activeAccordion) ) setActiveAccordion(payloadChild[0].id);

        return (
            <div>
                { !isEmpty(props.parentLanguageVersion.value) && (<h3>{props.parentLanguageVersion.value}</h3>) }
                <div className="accordion" id="accordion">
                    {
                        payloadChild.map((item) => (
                            <div className="accordion-item mb-3">
                                <h5 className="accordion-header">
                                    <button
                                        className={clsx("accordion-button",{"collapsed":activeAccordion!==item.id})}
                                        onClick={() => toggle(item.id)}
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#faq1"
                                        aria-expanded="true"
                                        aria-controls="faq1"
                                    >
                                        {item.name}
                                    </button>
                                </h5>
                                <div id={item.id}
                                    className={clsx("accordion-collapse collapse",{"show":activeAccordion===item.id})}
                                    data-bs-parent="#accordion"
                                >
                                    <RMDRComponentSanitizer
                                        languageVersion={item}
                                        variant="div"
                                        valueExpr="value"
                                        className="accordion-body"
                                        removeTag
                                    />
                                </div>
                            </div>
                        ))
                    }
                    
                </div>
            </div>
        )
    }

    return null;
}

const Component = React.memo(RMDRAccordion01, ( prevProps:TRMDRAccordion, nextProps:TRMDRAccordion ) => {
    console.log("RMDRAccordion01.memo", { prevProps, nextProps });
    return !( 
        prevProps.isLoading !== nextProps.isLoading 
        || prevProps.parentLanguageVersion !== nextProps.parentLanguageVersion
    );
});

export default Component;